import React from "react";
import { Checkbox } from "../../../../../components/__common/_controls/Checkbox/Checkbox";
import { ServiceEntity, ServiceStatus } from "../../../../../types/services";
import { REQUEST_TYPE } from "../../../../../types/user";
import { Col, Container, Row } from "../../../../../components/Grid/Grid";
import { SVG_ICONS } from "../../../../../components/__common/Svg/Svg";
import { Typography } from "../../../../../components/__common/Typography/Typography";
import { UtilsDateTime } from "../../../../../utils/UtilsDateTIme";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";
import { Image } from "../../../../../components/__common/Image";
import { LinkButton } from "../../../../../components/__common/_controls";
import { Toast } from "./Toast";

interface ServiceListSectionProps {
  servicesCount: number;
  requestType: REQUEST_TYPE;
  selectedServices: string[];
  services: ServiceEntity[];
  selectedServicesObject: ServiceEntity[];
  handleSelectAllOnChange: () => void;
  handleCheckboxOnChange: (service: ServiceEntity) => void;
  setIsServiceInfoOpen: (isOpen: boolean) => void;
  handleClickServiceLink: (e: any, service: ServiceEntity, jd: number) => void;
  setConfirmOpen: (isOpen: boolean) => void;
  myDataOnHandleClose: () => void;
}

export const ServicesListSection: React.FC<ServiceListSectionProps> = (Props) => {
  const {
    services,
    servicesCount,
    selectedServices,
    requestType,
    selectedServicesObject,
    handleSelectAllOnChange,
    handleCheckboxOnChange,
    setIsServiceInfoOpen,
    setConfirmOpen,
    handleClickServiceLink,
    myDataOnHandleClose
  } = Props
  const { t } = useTranslation();
  return (
    <>
      <div className="manage-apps__options-all">
        <Checkbox
          checkboxTestid="select-all"
          title={t("PRIVACY_MYDATA_MANAGE_SELECT_ALL")}
          name="all"
          textClassName="all-text"
          // disabled={servicesCount === 0}
          checked={
            servicesCount !== 0 && servicesCount === selectedServices.length
          }
          onChange={handleSelectAllOnChange}
          onKeyPress={handleSelectAllOnChange}
        />
        {/* <Typography component="span" variant="body2" className="count">
            {servicesCount}
        </Typography> */}
      </div>
      <hr />
      <div className="manage-apps__services">
        <Container>
          <Row>
            {services &&
              services.map((service) => {
                const serviceCode = service.service_code;
                return (
                  <Col sm={12} md={6} lg={4} key={serviceCode}>
                    <div className="manage-apps__services__checkbox">
                      <Checkbox
                        id={serviceCode}
                        testId="select-service-checkbox"
                        checkboxTestid="checkbox-keypress"
                        name="services"
                        title=""
                        textClassName="all-text"
                        checked={selectedServices.includes(serviceCode)}
                        disabled={
                          service.service_status === ServiceStatus.BUSY
                        }
                        onChange={() => handleCheckboxOnChange(service)}
                        onKeyPress={() => handleCheckboxOnChange(service)}
                      />
                    </div>
                    <div className="manage-apps__services__info">
                      <Image
                        className="manage-apps__services__info__icon"
                        image={service.service_icon_url}
                        width={64}
                        height={64}
                      />
                      <div>
                        <div className="manage-apps__services__info__titleContainer">
                          <LinkButton
                            testId="service-link"
                            title={
                              service.service_name ? service.service_name : ""
                            }
                            to="#"
                            icon={SVG_ICONS.GREATE_THAN_LRG}
                            iconPosition="right"
                            size="lg"
                            textClassName="manage-apps__services__info__name"
                            underlined={false}
                            id={service.service_name + service.service_code}
                            onClick={(e: any) => {
                              handleClickServiceLink(
                                e,
                                service,
                                service.joined_date
                              );
                              setIsServiceInfoOpen(true);
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <Typography
                          variant="flag"
                          className="manage-apps__services__info__joined"
                        >
                          {service.joined_date > 0 ? (
                            t("PRIVACY_MYDATA_MANAGE_JOINDATE", {
                              "%d": UtilsDateTime.convertJoinedDate(
                                service.joined_date
                              ),
                            })
                          ) : (
                            <>&nbsp;</>
                          )}
                        </Typography>
                      </div>
                      <hr />
                      <div className="manage-apps__services__info__busy">
                        <Typography
                          variant="body2"
                          className={classNames(
                            "manage-apps__services__info__text",
                            {
                              "manage-apps__services__info__busy__text":
                                service.service_status === ServiceStatus.BUSY,
                            }
                          )}
                        >
                          {service.service_status !== ServiceStatus.BUSY ? (
                            <Trans
                              values={{
                                "%s": service.service_name,
                              }}
                            >
                              {service.service_description}
                            </Trans>
                          ) : (
                            t("PRIVACY_MYDATA_MANAGE_LABEL_REQUESTING")
                          )}
                        </Typography>
                      </div>
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </div>
      {selectedServices.length > 0 && (
        <Toast
          onClickTestid="click-action-button"
          onClickAction={(val: boolean) => setConfirmOpen(val)}
          selectedCount={selectedServices.length}
          requestType={requestType}
          services={selectedServicesObject}
          onRemoveTestid="remove-button"
          onClickRemoveService={(sCode) => handleCheckboxOnChange(sCode)}
          onClose={myDataOnHandleClose}
        />
      )}
    </>
  );
}